<div class="main-container multi-turn-team">
  <mat-tab-group class="multichat-tabs">
    <mat-tab [label]="tabOneLabel">
      <div class="messages-container-inner">
        <div class="chat-placeholder-grid-container" *ngIf="!tabOneContent && !isLoading">
          <img
            *ngIf="tabOneImageSrc; else tabOneDefaultLogo"
            [src]="tabOneImageSrc"
            class="grid-item-logo vendor-logo"
            [alt]="tabOneLabel + ' logo'" />

          <ng-template #tabOneDefaultLogo>
            <img src="assets/svg/sosexy.png" class="grid-item-logo" [alt]="tabOneLabel + ' logo'" />
          </ng-template>

          <h1 class="placeholder-title">
            <span class="model-name" [style.color]="tabColor(0)">{{ tabOneLabel }}</span>
          </h1>

          <h1 class="placeholder-subtitle bigal-sub">{{ tabOnePlaceholder }}</h1>
        </div>

        <div class="message-content" *ngIf="tabOneContent">
          <div class="markdown prism-content" [innerHTML]="tabOneContent" appCodeHighlight></div>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="tabTwoLabel">
      <div class="messages-container-inner">
        <div class="chat-placeholder-grid-container" *ngIf="!tabTwoContent && !isLoading">
          <img
            *ngIf="tabTwoImageSrc; else tabTwoDefaultLogo"
            [src]="tabTwoImageSrc"
            class="grid-item-logo vendor-logo"
            [alt]="tabTwoLabel + ' logo'" />

          <ng-template #tabTwoDefaultLogo>
            <img src="assets/svg/sosexy.png" class="grid-item-logo" [alt]="tabTwoLabel + ' logo'" />
          </ng-template>

          <h1 class="placeholder-title">
            <span class="model-name" [style.color]="tabColor(1)">{{ tabTwoLabel }}</span>
          </h1>

          <h1 class="placeholder-subtitle bigal-sub">{{ tabTwoPlaceholder }}</h1>
        </div>

        <div class="message-content" *ngIf="tabTwoContent">
          <div class="markdown prism-content" [innerHTML]="tabTwoContent" appCodeHighlight></div>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="tabThreeLabel">
      <div class="messages-container-inner">
        <div class="chat-placeholder-grid-container" *ngIf="!tabThreeContent && !isLoading">
          <img
            *ngIf="tabThreeImageSrc; else tabThreeDefaultLogo"
            [src]="tabThreeImageSrc"
            class="grid-item-logo vendor-logo"
            [alt]="tabThreeLabel + ' logo'" />

          <ng-template #tabThreeDefaultLogo>
            <img src="assets/svg/sosexy.png" class="grid-item-logo" [alt]="tabThreeLabel + ' logo'" />
          </ng-template>

          <h1 class="placeholder-title">
            <span class="model-name" [style.color]="tabColor(2)">{{ tabThreeLabel }}</span>
          </h1>

          <h1 class="placeholder-subtitle bigal-sub">{{ tabThreePlaceholder }}</h1>
        </div>

        <div class="message-content" *ngIf="tabThreeContent">
          <div class="markdown prism-content" [innerHTML]="tabThreeContent" appCodeHighlight></div>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="tabFourLabel">
      <div class="messages-container-inner">
        <div class="chat-placeholder-grid-container" *ngIf="!tabFourContent && !isLoading">
          <img
            *ngIf="tabFourImageSrc; else tabFourDefaultLogo"
            [src]="tabFourImageSrc"
            class="grid-item-logo vendor-logo"
            [alt]="tabFourLabel + ' logo'" />

          <ng-template #tabFourDefaultLogo>
            <img src="assets/svg/sosexy.png" class="grid-item-logo" [alt]="tabFourLabel + ' logo'" />
          </ng-template>

          <h1 class="placeholder-title">
            <span class="model-name" [style.color]="tabColor(3)">{{ tabFourLabel }}</span>
          </h1>

          <h1 class="placeholder-subtitle bigal-sub">{{ tabFourPlaceholder }}</h1>
        </div>

        <div class="message-content" *ngIf="tabFourContent">
          <div class="markdown prism-content" [innerHTML]="tabFourContent" appCodeHighlight></div>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="tabFiveLabel">
      <div class="messages-container-inner">
        <div class="chat-placeholder-grid-container" *ngIf="!tabFiveContent && !isLoading">
          <img
            *ngIf="tabFiveImageSrc; else tabFiveDefaultLogo"
            [src]="tabFiveImageSrc"
            class="grid-item-logo vendor-logo"
            [alt]="tabFiveLabel + ' logo'" />

          <ng-template #tabFiveDefaultLogo>
            <img src="assets/svg/sosexy.png" class="grid-item-logo" [alt]="tabFiveLabel + ' logo'" />
          </ng-template>

          <h1 class="placeholder-title">
            <span class="model-name" [style.color]="tabColor(4)">{{ tabFiveLabel }}</span>
          </h1>

          <h1 class="placeholder-subtitle bigal-sub">{{ tabFivePlaceholder }}</h1>
        </div>

        <div class="message-content" *ngIf="tabFiveContent">
          <div class="markdown prism-content" [innerHTML]="tabFiveContent" appCodeHighlight></div>

          <div class="export-row" *ngIf="showExportButtons">
            <button class="btn-red-bigal me-3" type="button" (click)="exportPdf.emit()">
              Export to PDF
            </button>
            <button class="btn-red-bigal" type="button" (click)="exportDocx.emit()">
              Export to DOCX
            </button>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="messages-container">
    <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>
    <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
  </div>

  <div class="bottomcontainer" *ngIf="showInput">
    <div class="input-container">
      <div class="composer-shell">
        <div class="textarea-wrapper">
          <textarea
            #userInputTextarea
            class="user-input-textarea"
            [ngModel]="inputText"
            (ngModelChange)="onInputChange($event)"
            rows="1"
            [placeholder]="inputPlaceholder"
            [disabled]="inputDisabled"
            (keydown.enter)="onEnter($event)"
            (input)="autoResizeTextarea()">
          </textarea>

          <button
            class="btn-send-fixed"
            type="button"
            (click)="onSendOrAudio()"
            [disabled]="sendDisabled || inputDisabled">
            <ng-container *ngIf="inputText?.trim().length || !showAudioButton; else audioWaveIcon">
              <i class="fas fa-arrow-up"></i>
            </ng-container>
            <ng-template #audioWaveIcon>
              <img src="assets/icons/audio-wave.svg" class="audio-icon" alt="Audio" />
            </ng-template>
          </button>

          <div class="model-grid-inside">
            <div class="grid-item-inside selector repeat-selector" *ngIf="showRepeatPromptButton && !repeatPromptDisabled">
              <button
                id="previousPromptsBtn"
                class="elephant-btn lovesheet33"
                matTooltip="Click through your prompts (or press ↑)"
                (click)="onRepeatPrompt()"
                aria-label="Repeat previous prompt">
                <span class="btn-icon">
                  <i class="fas fa-clock-rotate-left"></i>
                </span>
                <span class="btn-text">Repeat Prompt</span>
              </button>
              <span class="repeat-hint">{{ repeatPromptHint }}</span>
            </div>

            <div class="grid-item-inside selector" *ngIf="showSelectorButton">
              <button
                id="aiCatalogBtn"
                class="elegant-btn lovesheet33"
                (click)="onOpenSelector()"
                aria-label="Open AI menu">
                <span class="btn-icon">
                  <img [src]="selectorIconSrc" class="selectai-icon" />
                </span>
                <span class="btn-text">{{ selectorLabel }}</span>
                <i class="fas fa-chevron-down btn-chevron"></i>
              </button>
            </div>

            <div
              class="grid-item-inside selector tools-selector"
              *ngIf="showToolsMenuButton"
              (click)="onToolsMenuToggle()">
              <div class="video-menu-anchor" (click)="$event.stopPropagation()">
                <div
                  class="video-generator-menu"
                  [class.open]="toolsMenuOpen"
                  *ngIf="toolsMenuOpen">
                  <ng-content select="[multi-tab-tools-menu]"></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
